export function loadExternalCss(
  href: string,
  integrity?: string,
): Promise<HTMLLinkElement> {
  return new Promise((resolve, reject) => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    link.type = "text/css";

    if (integrity) {
      link.integrity = integrity;
      link.crossOrigin = "anonymous";
    }

    link.onload = () => resolve(link);
    link.onerror = () => reject(new Error(`Failed to load CSS: ${href}`));

    document.head.appendChild(link);
  });
}
